import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  IWeeklyUpdatesPaginatedResponse,
  getWeeklyUpdatesPaginated,
} from "api";
import { Nullable } from "config";
import { RootState } from "store";

import { WeeklyUpdateModalModes } from "./enums";
import { IWeeklyUpdateModal } from "./types";

const initialState = {
  weeklyUpdatesData: null as Nullable<IWeeklyUpdatesPaginatedResponse["edges"]>,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: WeeklyUpdateModalModes.VIEW,
  } as IWeeklyUpdateModal,
};

export const fetchWeeklyUpdates = createAsyncThunk(
  "weekly-updates/fetchWeeklyUpdates",
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getWeeklyUpdatesPaginated(filters);
    return response;
  }
);

const weeklyUpdatesSlice = createSlice({
  name: "weekly-updates",
  initialState,
  reducers: {
    setWeeklyUpdatesModalData: (
      state,
      action: PayloadAction<IWeeklyUpdateModal>
    ) => {
      state.modalData = action.payload;
    },
    closeWeeklyUpdatesModal: (state) => {
      state.modalData = initialState.modalData;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchWeeklyUpdates.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        weeklyUpdatesData: action.payload?.edges ?? null,
        totalCount: action.payload?.totalCount ?? 1,
      };
    });
    builder.addCase(fetchWeeklyUpdates.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const { setWeeklyUpdatesModalData, closeWeeklyUpdatesModal } =
  weeklyUpdatesSlice.actions;

export default weeklyUpdatesSlice.reducer;
